export default from './comment';



// WEBPACK FOOTER //
// ./app/components/comment/index.js